const l = {
  name: "FacebookSmall",
  dimensions: { width: 24, height: 24 },
  content: `
  <svg fill="none">
    <g clip-path="url(#clip0_21_2240)">
        <path fill="currentColor"
            d="M12 0C18.6275 0 24 5.40532 24 12.0734C24 18.0996 19.6116 23.0944 13.8748 24V15.5642H16.6711L17.2027 12.0734H13.8748V9.80844C13.8748 8.85434 14.339 7.92217 15.8307 7.92217H17.3444V4.95092C17.3444 4.95092 15.9708 4.71496 14.6579 4.71496C11.9174 4.71496 10.1252 6.3856 10.1252 9.41275V12.0732H7.07753V15.564H10.1252V23.9998C4.38836 23.0942 0 18.0994 0 12.0732C0 5.40532 5.37254 0 12 0Z"
        />
    </g>
    <defs>
        <clipPath id="clip0_21_2240">
            <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
    </defs>
  </svg>
`
};
export {
  l as FacebookSmall
};
